import 'react-toastify/dist/ReactToastify.css';

import './scss/index.scss';

import { useCheckAuth } from '~modules/auth/model/use-check-auth.ts';
import { AuthProvider } from '~modules/auth/ui/index.ts';

import { AppRouter } from './app.router';

export function App() {
	const { user, error, isPending, logout } = useCheckAuth();

	return (
		<AuthProvider user={user} logout={logout} error={error} isPending={isPending}>
			<AppRouter />
		</AuthProvider>
	);
}
